module.exports = "<p-multiSelect \r\n    defaultLabel=\"Employees\" \r\n    [options]=\"selectItems\" \r\n    [(ngModel)]=\"selectedIDs\">\r\n</p-multiSelect>"